<div [class]="computedAccordionClasses()">
  <!-- Glass shimmer effect -->
  <div
    class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-lg">
    <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                    transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                    transition-transform duration-1500 ease-out"></div>
  </div>

  <!-- Premium floating particles -->
  @if (variant === 'premium') {
  <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20 rounded-lg">
    <div class="absolute top-1/4 left-1/6 w-1.5 h-1.5 bg-primary-400/40 rounded-full animate-pulse"></div>
    <div class="absolute bottom-1/3 right-1/4 w-1 h-1 bg-white/30 rounded-full animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-3/4 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
  </div>
  }

  <!-- Accordion Items -->
  <div class="relative z-10">
    @for (item of items; track item.id + '-' + i; let i = $index) {
    <div [class]="getItemClasses(item)">
      <!-- Accordion Header -->
      <button [class]="getHeaderClasses(item)" [disabled]="item.disabled" [attr.aria-expanded]="isExpanded(item.id)"
        [attr.aria-controls]="'accordion-content-' + item.id" [id]="'accordion-header-' + item.id"
        (click)="toggleItem(item.id)" (keydown)="handleKeyDown($event, i)">
        <div class="flex items-center space-x-3 relative z-10">
          <!-- Item Icon -->
          @if (item.icon) {
          <ui-icon [name]="item.icon" [size]="iconSize()" customClass="transition-colors duration-300"
            [class.text-primary-600]="isExpanded(item.id)" [class.dark:text-primary-400]="isExpanded(item.id)"
            [class.text-gray-600]="!isExpanded(item.id)" [class.dark:text-gray-300]="!isExpanded(item.id)"></ui-icon>
          }

          <!-- Item Title -->
          <span class="font-semibold">{{ item.title }}</span>

          <!-- Item Badge -->
          @if (item.badge) {
          <span class="px-2 py-0.5 text-xs bg-red-500/80 text-white rounded-full backdrop-blur-sm">
            {{ item.badge }}
          </span>
          }
        </div>

        <!-- Chevron Icon -->
        <ui-icon name="chevron-down" [size]="iconSize()" [class]="getChevronClasses(item.id)"></ui-icon>

        <!-- Header glass shimmer effect -->
        <div
          class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-lg">
          <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/15 to-transparent
                            transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                            transition-transform duration-1000 ease-out"></div>
        </div>

        <!-- Premium floating particles on header -->
        @if (variant === 'premium' && isExpanded(item.id)) {
        <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20 rounded-lg">
          <div class="absolute top-1/3 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
          <div class="absolute bottom-1/3 right-1/3 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse delay-500"></div>
        </div>
        }
      </button>

      <!-- Accordion Content -->
      <div [id]="'accordion-content-' + item.id" [attr.aria-labelledby]="'accordion-header-' + item.id" role="region"
        class="transition-all duration-300 ease-out overflow-hidden"
        [style.max-height]="isExpanded(item.id) ? getContentHeight(item.id) : '0px'"
        [style.opacity]="isExpanded(item.id) ? '1' : '0'">
        <div [class]="computedContentClasses()" [id]="'content-' + item.id">
          <div class="py-4 relative z-10" [attr.data-accordion-item]="item.id">
            <!-- Default content -->
            @if (item.content) {
            <p class="text-gray-600 dark:text-gray-300 leading-relaxed">
              {{ item.content }}
            </p>
            }
          </div>

          <!-- Content glass accent -->
          <div class="absolute inset-0 bg-linear-to-b from-primary-500/5 to-transparent opacity-50"></div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Expanded state glow -->
  @if (hasExpandedItems()) {
  <div class="absolute inset-0 rounded-lg opacity-30 pointer-events-none">
    <div class="absolute inset-0 bg-primary-500/5 rounded-lg animate-glass-pulse"></div>
  </div>
  }

  <!-- Custom content projection - use data-accordion="item-id" on your elements -->
  <!-- Note: Due to Angular limitations, you must handle visibility with CSS: [data-accordion]:not([data-accordion="activeId"]) { display: none; } -->
  <div class="accordion-custom-content">
    <ng-content></ng-content>
  </div>
</div>